export default "https://c.travel-assets.com/partner-portal/laptop.737d25456e1a.svg";